import { api } from '../api/client';

let onBlockStartingSoon: ((block: { id: string; title: string; scheduledStartTime: string }) => void) | null = null;

export function setTimelineBlockCallback(cb: (block: { id: string; title: string; scheduledStartTime: string }) => void) {
  onBlockStartingSoon = cb;
}

export async function requestNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

function showBrowserNotification(title: string, body: string) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  new Notification(title, { body, icon: '/favicon.ico' });
}

async function checkUpcomingBlocks() {
  try {
    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const blocks = await api.timelineBlocks.startingSoon(today);
    for (const block of blocks) {
      showBrowserNotification('Stride', `${block.title} starts at ${block.scheduledStartTime}`);
      if (onBlockStartingSoon) onBlockStartingSoon(block);
      await api.timelineBlocks.markNotified(block.id);
    }
  } catch (err) {
    console.error('[timelineBlockChecker] Failed to check upcoming blocks:', err);
  }
}

let intervalId: ReturnType<typeof setInterval> | null = null;

export function startTimelineBlockChecker() {
  if (intervalId) return;
  checkUpcomingBlocks();
  intervalId = setInterval(checkUpcomingBlocks, 60_000);
}

export function stopTimelineBlockChecker() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}
